const FacultyProfileList = () => {
  return <div>FacultyProfileList</div>;
};

export default FacultyProfileList;
